import { NgModule } from '@angular/core';
import { TypeProposalComponent } from './type-proposal.component';
import { CommonModule } from '@angular/common';
import { SelectInputModule } from '../../inputs/select/select.module';

@NgModule({
  declarations: [TypeProposalComponent],
  imports: [CommonModule, SelectInputModule],
  exports: [TypeProposalComponent],
})
export class TypeProposalModule {}
